import { ContactCornSchema } from '@eigtech/contacts-types';
import { EventBaseSchema, eventType } from '@eigtech/event-stream-types';
import { z } from 'zod';
const estimatorServiceName = 'estimator';
const estimatorServiceEventType = (entity, eventName) => eventType(estimatorServiceName, entity, eventName);
const estimatorPortalEventType = (eventName) => estimatorServiceEventType('portal', eventName);
const EstimatorServiceEventBaseSchema = EventBaseSchema.merge(z.object({
    type: estimatorServiceEventType(),
}));
export const DeprecatedEstimatorPortalOriginSchema = z.enum(['API', 'PROJECTION']);
export const DEPRECATED_ESTIMATOR_PORTAL_ORIGIN = DeprecatedEstimatorPortalOriginSchema.enum;
export const DeprecatedEstimatorPortalStatusSchema = z.enum(['ACTIVE', 'INACTIVE']);
export const DEPRECATED_ESTIMATOR_PORTAL_STATUS = DeprecatedEstimatorPortalStatusSchema.enum;
export const DeprecatedEstimatorPortalSchema = z.object({
    auth0Id: z.string().optional(),
    contactId: ContactCornSchema,
    claimNumber: z.string(),
    dateCreated: z.string().datetime(),
    dateModified: z.string().datetime(),
    createdBy: z.string(),
    modifiedBy: z.string(),
    status: DeprecatedEstimatorPortalStatusSchema,
    origin: DeprecatedEstimatorPortalOriginSchema,
});
export const DeprecatedEstimatorPortalEventSchema = EstimatorServiceEventBaseSchema.merge(z.object({
    type: estimatorPortalEventType(),
    portal: DeprecatedEstimatorPortalSchema,
}));
export const DeprecatedEstimatorPortalActivatedEventSchema = DeprecatedEstimatorPortalEventSchema.merge(z.object({
    type: estimatorPortalEventType('activated'),
}));
export const DeprecatedEstimatorPortalDeactivatedEventSchema = DeprecatedEstimatorPortalEventSchema.merge(z.object({
    type: estimatorPortalEventType('deactivated'),
}));
export const isDeprecatedEstimatorPortalEvent = (event) => DeprecatedEstimatorPortalEventSchema.safeParse(event).success;
